var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrint(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.15388 8.41504H4.61542C4.19059 8.41504 3.84619 8.75944 3.84619 9.18427C3.84619 9.6091 4.19059 9.9535 4.61542 9.9535H6.15388C6.57872 9.9535 6.92311 9.6091 6.92311 9.18427C6.92311 8.75944 6.57872 8.41504 6.15388 8.41504Z",
    fill: "url(#paint0_linear_1171_12373)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5769 17.6925H16.1538V14.6155H6.92308V17.6925H2.5C1.83696 17.6925 1.20107 17.4291 0.732233 16.9602C0.263392 16.4914 0 15.8555 0 15.1925V7.88477C0 7.22172 0.263392 6.58584 0.732233 6.117C1.20107 5.64816 1.83696 5.38477 2.5 5.38477H20.5769C21.24 5.38477 21.8759 5.64816 22.3447 6.117C22.8135 6.58584 23.0769 7.22172 23.0769 7.88477V15.1925C23.0769 15.8555 22.8135 16.4914 22.3447 16.9602C21.8759 17.4291 21.24 17.6925 20.5769 17.6925ZM17.6923 16.154H20.5769C20.7032 16.154 20.8282 16.1291 20.9449 16.0808C21.0615 16.0325 21.1675 15.9617 21.2568 15.8724C21.3461 15.7831 21.4169 15.6771 21.4653 15.5604C21.5136 15.4438 21.5385 15.3187 21.5385 15.1925V7.88477C21.5385 7.62975 21.4372 7.38518 21.2568 7.20486C21.0765 7.02453 20.8319 6.92323 20.5769 6.92323H2.5C2.24498 6.92323 2.00041 7.02453 1.82009 7.20486C1.63977 7.38518 1.53846 7.62975 1.53846 7.88477V15.1925C1.53846 15.3187 1.56333 15.4438 1.61165 15.5604C1.65998 15.6771 1.7308 15.7831 1.82009 15.8724C1.90938 15.9617 2.01538 16.0325 2.13204 16.0808C2.24869 16.1291 2.37373 16.154 2.5 16.154H5.38462V14.354C5.38462 14.0153 5.51915 13.6905 5.75862 13.4511C5.99809 13.2116 6.32288 13.0771 6.66154 13.0771H16.4154C16.5831 13.0771 16.7491 13.1101 16.904 13.1743C17.059 13.2384 17.1997 13.3325 17.3183 13.4511C17.4369 13.5696 17.5309 13.7104 17.5951 13.8653C17.6593 14.0203 17.6923 14.1863 17.6923 14.354V16.154Z",
    fill: "url(#paint1_linear_1171_12373)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8462 20H7.2308C6.74117 20 6.27159 19.8055 5.92537 19.4593C5.57915 19.1131 5.38464 18.6435 5.38464 18.1538V14.3538C5.38464 14.0152 5.51918 13.6904 5.75865 13.4509C5.99812 13.2115 6.32291 13.0769 6.66157 13.0769H16.4154C16.5831 13.0769 16.7491 13.11 16.9041 13.1741C17.059 13.2383 17.1998 13.3324 17.3183 13.4509C17.4369 13.5695 17.531 13.7103 17.5951 13.8652C17.6593 14.0201 17.6923 14.1862 17.6923 14.3538V18.1538C17.6923 18.6435 17.4978 19.1131 17.1516 19.4593C16.8054 19.8055 16.3358 20 15.8462 20ZM6.92311 14.6154V18.1538C6.92506 18.2348 6.9581 18.312 7.01539 18.3693C7.07267 18.4265 7.14981 18.4596 7.2308 18.4615H15.8462C15.9272 18.4596 16.0043 18.4265 16.0616 18.3693C16.1189 18.312 16.1519 18.2348 16.1539 18.1538V14.6154H6.92311ZM17.6923 6.92308H5.38464V1.84615C5.38464 1.60371 5.4324 1.36365 5.52517 1.13966C5.61795 0.915676 5.75394 0.712157 5.92537 0.540726C6.27159 0.194505 6.74117 0 7.2308 0H15.8462C16.3358 0 16.8054 0.194505 17.1516 0.540726C17.4978 0.886947 17.6923 1.35652 17.6923 1.84615V6.92308ZM6.92311 5.38462H16.1539V1.84615C16.1539 1.76455 16.1215 1.68629 16.0638 1.62858C16.0061 1.57088 15.9278 1.53846 15.8462 1.53846H7.2308C7.14919 1.53846 7.07093 1.57088 7.01323 1.62858C6.95552 1.68629 6.92311 1.76455 6.92311 1.84615V5.38462Z",
    fill: "url(#paint2_linear_1171_12373)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1171_12373",
    x1: 5.38465,
    y1: 8.41504,
    x2: 5.38465,
    y2: 9.9535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA6FFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#711CF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1171_12373",
    x1: 11.5385,
    y1: 5.38477,
    x2: 11.5385,
    y2: 17.6925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA6FFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#711CF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1171_12373",
    x1: 11.5385,
    y1: 0,
    x2: 11.5385,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA6FFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#711CF1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.f3861fae9ff41c06f9b062d77426742d.svg";
export { ForwardRef as ReactComponent };